module.exports = __webpack_public_path__ + "img/playngo.2edd610d.svg";